<template>
  <div class="row">

    <div class="col-3 mb-3" v-for="(item, index) in items" :key="index">
      <div class="custom_car_inner">
        <div class="title ">
          <i class="icon" :style="`background-image: url('/img/parts_icon/${item.default_icon}');`"></i>
          {{ item.name }}
        </div>
        <vc-donut :sections="sectionsMake(item)"
                  :size="100" :thickness="15" unit="px">
          <p class="center_text1 m-0">{{ persentText(item.default_km, item.over_km) }}%</p>
          <!-- p class="center_text2 m-0"><span>{{ lastText(item.pseq) }}</span><span>{{ persentText(item.default_km, item.over_km) }}%</span></p -->
        </vc-donut>
        <p class="date">
          <span v-if="item.default_km > 0">교체주기 {{ item.default_km | comma }}km</span>
          <span v-if="item.default_month > 0"> │ {{ item.default_month | comma }}개월</span>
        </p>
        <p class="km">
          <span v-if="item.change_km && (item.now_total_km - item.change_km) > 0">
            {{ (item.now_total_km - item.change_km) | comma }}km 사용 │
          </span>
          <span>
            <span v-if="item.over_km > 0" style="color:#F9385F;">{{ item.over_km }}km 초과</span>
            <span v-else>주행 정상</span>
            <span v-if="item.over_month > 0" style="color:#F9385F;"> │ {{ item.over_month }}개월 초과</span>
            <span v-else-if="item.default_month > 0"> │ 개월 정상</span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
import ax from '@/api/parts'

Vue.use(Donut)

export default {
  name: 'CarExpendAbles',
  components: {},
  data () {
    return {
      items: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      ax.expendParts(this.$route.params.seq, (data) => {
        if (data) {
          this.items = data
        }
      })
    },
    persentText: (defaultKm, overKm) => {
      if (overKm > 0) {
        return Math.round((overKm / defaultKm) * 100)
      } else {
        return 0
      }
    },
    sectionsMake: (item) => {
      let v = 0
      let c = ''
      if (item.over_km > 0) {
        v = Math.round((item.over_km / item.default_km) * 100)
      }
      if (v > 80) {
        c = '#F9385F'
      } else if (v > 50) {
        c = '#FEAB39'
      } else if (v > 20) {
        c = '#007DEF'
      } else if (v > 0) {
        c = '#ececec'
      }
      return [{ label: item.name, value: v, color: c }]
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_car_inner {
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px;
  position: relative;

  .title {
    position: relative;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;

    .icon {
      display: inline-block;
      content: ' ';
      width: 20px;
      height: 16px;
      vertical-align: middle;
      margin-top: -2px;
      margin-right: 4px;
      background: {
        position: center center;
        repeat: no-repeat;
      };

    }

  }

  .cdc-container {
    padding: 15px;

    .center_text1 {
      font-size: 24px;
      color: #F9385F;
    }

    .center_text2 {
      color: #007DEF;
      font-size: 24px;

      span:first-child {
        display: block;
        color: #000;
        font-size: 12px;
      }
    }

    .center_text3 {
      font-size: 24px;
      color: #FEAB39;
    }

    .center_text4 {
      font-size: 24px;
      color: #007DEF;
    }

  }

  .date {
    font-size: 12px;
    color: #979799;
    margin-bottom: 5px;
  }

  .km {
    font-size: 12px;
    color: #000;
    margin-bottom: 5px;
  }

  .custom_btns_group {
    position: absolute;
    right: 15px;
    top: 10px;

    .btn {
      background: #F8F8FB !important;

      &.active {
        color: #fff;
        background: #007DEF !important;
      }
    }

  }
}
</style>
